'use strict';

require('./oracle.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _marketoForm = require('hellosign/components/marketo-form');

var _marketoForm2 = _interopRequireDefault(_marketoForm);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _clouds_oracle = require('landing-pages/assets/clouds_oracle.svg');

var _clouds_oracle2 = _interopRequireDefault(_clouds_oracle);

var _HS_logo_white = require('landing-pages/assets/HS_logo_white.svg');

var _HS_logo_white2 = _interopRequireDefault(_HS_logo_white);

var _oracle_logo = require('landing-pages/assets/oracle_logo.svg');

var _oracle_logo2 = _interopRequireDefault(_oracle_logo);

var _overlay_left = require('landing-pages/assets/overlay_left.svg');

var _overlay_left2 = _interopRequireDefault(_overlay_left);

var _overlay_right = require('landing-pages/assets/overlay_right.svg');

var _overlay_right2 = _interopRequireDefault(_overlay_right);

var _clock_icon = require('landing-pages/assets/clock_icon.svg');

var _clock_icon2 = _interopRequireDefault(_clock_icon);

var _notifications_icon = require('landing-pages/assets/notifications_icon.svg');

var _notifications_icon2 = _interopRequireDefault(_notifications_icon);

var _cloud_icon_bw = require('landing-pages/assets/cloud_icon_bw.svg');

var _cloud_icon_bw2 = _interopRequireDefault(_cloud_icon_bw);

var _socialSection = require('landing-pages/components/common/social-section');

var _socialSection2 = _interopRequireDefault(_socialSection);

var _benefitsSection = require('landing-pages/components/common/benefits-section');

var _benefitsSection2 = _interopRequireDefault(_benefitsSection);

var _pricingCtaSection = require('landing-pages/components/common/pricing-cta-section');

var _pricingCtaSection2 = _interopRequireDefault(_pricingCtaSection);

var _faqSection = require('landing-pages/components/common/faq-section');

var _faqSection2 = _interopRequireDefault(_faqSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Oracle(p) {
    // Oracle constants
    var benefits = [{
        icon: _clock_icon2['default'],
        title: 'Reduce time preparing important agreements',
        text: 'Send your documents out for signature directly from Documents Cloud and avoid toggling between different applications.'
    }, {
        icon: _notifications_icon2['default'],
        title: 'Monitor your documents in real time',
        text: 'You’ll know when your document is signed in Documents Cloud by way of a status icon and through email notifications so you’re never left wondering.'
    }, {
        icon: _cloud_icon_bw2['default'],
        title: 'Find your documents easily in Documents Cloud',
        text: 'Stop digging through your inbox to find your signed document. All your signed docs are automatically saved in your Documents Cloud account.'
    }];
    var twitterLink = 'https://twitter.com/intent/tweet?text=Check%20out%20HelloSign%20for%20Oracle%20Documents%20Cloud.%20https%3A%2F%2Fwww.hellosign.com%2Foracle%3Futm_campaign%3DORC-082016%26utm_medium%3Ds2s%26utm_source%3Dtwitter&source=clicktotweet&related=clicktotweet';
    var facebookLink = 'https://www.facebook.com/sharer/sharer.php?u=http%3A//www.hellosign.com/oracle?utm_campaign=ORC-082016%26utm_medium=s2s%26utm_source=facebook';
    var linkedInLink = 'https://www.linkedin.com/shareArticle?mini=true&url=http%3A//www.hellosign.com/oracle?utm_campaign=ORC-082016%26utm_medium=s2s%26utm_source=linkedin&title=Check%20out%20HelloSign%20for%20Oracle%20Documents%20Cloud&summary=&source=';
    var border = '2px solid #D7D7D7';
    var ctaText = 'Get this integration started today.';
    var linkText = 'Contact our Sales team';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations oracle' },
        _react2['default'].createElement(IllustrationArea, null),
        _react2['default'].createElement(
            'div',
            { className: 'seo-cloud-integrations__main', style: { backgroundColor: 'white' } },
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'top',
                text: ctaText,
                linkText: linkText,
                onClick: handleClick,
                style: { borderBottom: border, backgroundColor: '#F7F8F9', fontWeight: 600 } }),
            _react2['default'].createElement(_benefitsSection2['default'], { benefits: benefits }),
            _react2['default'].createElement(HowItWorks, null),
            _react2['default'].createElement(_socialSection2['default'], { title: 'Share with your networks!',
                twitterLink: twitterLink,
                facebookLink: facebookLink,
                linkedInLink: linkedInLink }),
            _react2['default'].createElement(_faqSection2['default'], { link: 'https://faq.hellosign.com/hc/en-us/sections/205421488-Oracle' }),
            _react2['default'].createElement(_pricingCtaSection2['default'], { position: 'bottom',
                text: ctaText,
                linkText: linkText,
                onClick: handleClick,
                style: { borderTop: border, fontWeight: 600 } })
        )
    );
}

function IllustrationArea(p) {
    return _react2['default'].createElement(
        'div',
        { className: 'top row', style: { backgroundColor: '#FFD58D' } },
        _react2['default'].createElement(
            'div',
            { className: 'top-content-container large-5 large-push-6 columns' },
            _react2['default'].createElement(
                'div',
                { className: 'hellosign-dropbox' },
                _react2['default'].createElement('img', { src: _HS_logo_white2['default'], alt: 'HelloSign Logo', className: 'hs-logo' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'plus' },
                    '+'
                ),
                _react2['default'].createElement('img', { src: _oracle_logo2['default'], alt: 'Oracle Logo', className: 'dropbox-logo', width: '130' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'title' },
                _react2['default'].createElement(
                    'h1',
                    null,
                    'Request signatures straight from Oracle Documents Cloud'
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'subtitle' },
                _react2['default'].createElement(
                    'h2',
                    { style: { fontWeight: 400, fontSize: 16, maxWidth: 600 } },
                    'Integrate HelloSign with Oracle Documents Cloud to request signatures for your contracts, agreements, and waivers. You can check the signature status in real time, and the signed document is automatically saved in Documents Cloud for easy access.'
                )
            ),
            _react2['default'].createElement(ContactSalesButton, null)
        ),
        _react2['default'].createElement(
            'div',
            { className: 'clouds-container large-5 large-pull-4 columns', style: { float: 'left' } },
            _react2['default'].createElement('img', { src: _clouds_oracle2['default'], alt: 'cloud left', style: { marginTop: 60, width: 550 } })
        ),
        _react2['default'].createElement('img', { src: _overlay_left2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud left', className: 'cloud-left' }),
        _react2['default'].createElement('img', { src: _overlay_right2['default'], style: { transform: 'translateY(1px)' }, alt: 'cloud right', className: 'cloud-right' })
    );
}

function ContactSalesButton(p) {
    return _react2['default'].createElement(_button2['default'], {
        buttonText: 'Contact sales',
        buttonColor: 'cerulean',
        buttonBorderColor: 'cerulean',
        buttonHoverColor: 'white',
        buttonHoverTextColor: 'cerulean',
        onClick: handleClick });
}

function handleClick(e) {
    e.preventDefault();

    // Click handler to launch contact sales modal
    var attachPoint = _hfReactHelper2['default'].getRevealAttachPoint('contact_sales_modal');
    var node = _reactDom2['default'].render(_react2['default'].createElement(_marketoForm2['default'], { formId: 1249, trackingId: 'oracle-contact' }), attachPoint);
    $(document).foundation();
    $(_reactDom2['default'].findDOMNode(node)).closest('.reveal-modal').foundation('reveal', 'open');
}

function HowItWorks(p) {
    var paragraphStyle = {
        marginLeft: 20
    };
    var videoProps = {
        src: 'https://www.youtube.com/embed/1Z6KHuKTQd4',
        frameBorder: 0,
        style: {
            width: '100%',
            maxWidth: 800,
            height: 430
        }
    };
    // For linter
    var approvalText = 'In the menu, click "More" and choose "Gather approval signatures." This will launch HelloSign, allowing you to quickly prepare your document for signature.';

    return _react2['default'].createElement(
        'div',
        { className: 'seo-cloud-integrations__how-it-works' },
        _react2['default'].createElement(
            'h2',
            null,
            'How it Works'
        ),
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement(
                'div',
                { className: 'screenshot-explanation large-4 large-push-8 columns' },
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'To get started, select the document you\'d like signed from your documents list in Oracle Documents Cloud.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    approvalText
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle },
                    'After you send your document for signature, retrieve the signed document by clicking \u201CGet Signed File\u201D in the menu. Your document will automatically be added into your Documents Cloud account.'
                ),
                _react2['default'].createElement(
                    'p',
                    { style: paragraphStyle, onClick: handleClick },
                    _react2['default'].createElement(
                        'span',
                        { style: { color: '#00B3E6', cursor: 'pointer', fontWeight: 400 } },
                        'Contact sales to get started.'
                    )
                )
            ),
            _react2['default'].createElement(
                'div',
                { className: 'dropbox-screenshot large-8 large-pull-4 columns' },
                _react2['default'].createElement('iframe', videoProps)
            )
        )
    );
}

module.exports = Oracle;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/oracle.jsx
 ** module id = 1620
 ** module chunks = 0
 **/